<template>
  <div class="light-box">
    <div
      class="modal fade"
      :id="targetId"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div
            class="modal-custom-swiper-btn swiper-button-prev"
            @click="slidePrev"
          ></div>
          <div class="modal-header border-0">
            <button
              type="button"
              class="btn-close position-absolute"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div class="modal-body d-flex align-items-center position-relative">
            <swiper
              :navigation="true"
              :modules="swiperOptions.modules"
              class="mySwiper"
              :onSwiper="onSwiperInit"
              :loop="loop"
            >
              <swiper-slide v-for="img in images">
                <div class="position-relative">
                  <img
                    :src="img.imgLink"
                    :alt="img.altText"
                    class="fit-cover h-100 w-100"
                  />
                  <div
                    class="image-description position-absolute w-100 text-center"
                    v-html="img.description"
                    v-if="img.description"
                  />
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div
            class="modal-custom-swiper-btn swiper-button-next"
            @click="slideNext"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper";

const swiperInstance = ref(null);

const onSwiperInit = (swiper) => (swiperInstance.value = swiper);

const slideTo = (index) => swiperInstance.value.slideTo(index);
const slideToLoop = (index) => {
  swiperInstance.value.slideToLoop(index, 0); // for some reason after reopening the lightbox
                                              // the prev/next methods doesn't work without second argument in slideToLoop
};

const slideNext = () => swiperInstance.value.slideNext();
const slidePrev = () => swiperInstance.value.slidePrev();

const swiperOptions = {
  modules: [Navigation],
};

const props = defineProps({
  images: Array,
  slideIndex: Number,
  targetId: String,
  loop: {
    type: Boolean,
    default: false,
  },
});

watch(
  () => props.slideIndex,
  (newIndex) => {
    props.loop ? slideToLoop(newIndex) : slideTo(newIndex);
  }
);
</script>
